import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import DirectionsIcon from '@material-ui/icons/Directions';
import Chip from '@material-ui/core/Chip';
import ErrorIcon from '@material-ui/icons/Error';
import CircularProgress from '@material-ui/core/CircularProgress';
import srchBack from './images/srchback.png'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 1400,
    position: 'relative',
    left: '100px',
    top: '30%',
    backgroundColor:'#00e5f5',
    backgroundImage:`url(${srchBack})`
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    backgroundColor:'#00e5f5',
    backgroundImage:`url(${srchBack})`
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default function CustomizedInputBase(props) {
  const classes = useStyles();
  const [srchVal,setSrchval]=useState(false)
  const [srchErr,setSrchErr]=useState(false)
  const [srchnodta,setSrchnodta]=useState(false)
  const [srchingflg,setsrchng]=useState(false)
  const [srchTxt,setSrchtxt]=useState('')

  async function onKeyUp(event){
    // event.stopPropagation();
    
    if (event.key === "Enter") {
      event.stopPropagation();
      event.preventDefault();
      console.log('this is enter')
      setSrchnodta(false)
    setSrchErr(false)
    setsrchng(true)

    if(srchTxt===''){
      setSrchval(true)
      setsrchng(false)
      return
    }
    const srchArry=transformSearchtxt(srchTxt)
    if(srchArry.length===0){
      setSrchval(true)
      setsrchng(false)
      return
    }
    const apiurl=`${process.env.REACT_APP_API_HOST}/searchtxt`
    const databody={
      zip: srchArry[0],
      searchtext: srchArry[1]
    }
    try{
      const respdata=await fetch(apiurl,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(databody)
      })
      // console.log(respdata)
      if(respdata.status===404){
        throw Error('not found')
      }
      if(respdata.status!==200){
        throw Error('error in searching')
      }
      const respjson=await respdata.json()
      setsrchng(false)
      // console.log(respjson)
      props.setSrchresultname(respjson.filename)
      props.clickSrch(false)
    }catch(e){
      if(e.message==='not found'){
        setSrchnodta(true)
      }else{
        setSrchErr(true)
      }     
      setsrchng(false)
      
    }
    }
    
  }

  function changeSrchtext(event){
    // console.log(event.target.value)
    setSrchnodta(false)
    setSrchErr(false)
    setSrchval(false)
    const changedVal=event.target.value
    setSrchtxt(changedVal)
  }

  function transformSearchtxt(input){
    let tmp1=input.split(' ')
    if(tmp1.length<2){
      return []
    }
    const zipcode=tmp1[0]
    let srchitm=''
    if (tmp1.length>2){
      let tmp2=tmp1.slice(1,tmp1.length)
      // console.log(tmp2.join(' '))
      srchitm=tmp2.join(' ')
    }else{
      srchitm=tmp1[1]
    }
    return [zipcode,srchitm]
  }

  async function getSrchResults(){
    setSrchnodta(false)
    setSrchErr(false)
    setsrchng(true)

    if(srchTxt===''){
      setSrchval(true)
      return
    }
    const srchArry=transformSearchtxt(srchTxt)
    if(srchArry.length===0){
      setSrchval(true)
      return
    }
    const apiurl=`${process.env.REACT_APP_API_HOST}/searchtxt`
    const databody={
      zip: srchArry[0],
      searchtext: srchArry[1]
    }
    try{
      const respdata=await fetch(apiurl,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(databody)
      })
      // console.log(respdata)
      if(respdata.status===404){
        throw Error('not found')
      }
      if(respdata.status!==200){
        throw Error('error in searching')
      }
      const respjson=await respdata.json()
      setsrchng(false)
      // console.log(respjson)
      props.setSrchresultname(respjson.filename)
      props.clickSrch(false)
    }catch(e){
      if(e.message==='not found'){
        setSrchnodta(true)
      }else{
        setSrchErr(true)
      }     
      setsrchng(false)
      
    }
    
  }

  

  return (
      <div className='websearchbarcont' >
        {srchVal && <Chip color="secondary" icon={<ErrorIcon />} label='Please enter a proper search' style={{position:'relative',left:'100px',marginBottom:'2px'}} />}
        {srchErr && <Chip color="secondary" icon={<ErrorIcon />} label='Error in searching!! Please try again' style={{position:'relative',left:'100px',marginBottom:'2px'}} />}
        {srchnodta && <Chip color="secondary" icon={<ErrorIcon />} label='Nothing found !! Please try again' style={{position:'relative',left:'100px',marginBottom:'2px'}} /> }  
          <Paper component="form" className={classes.root} elevation={20}>
      {/* <IconButton className={classes.iconButton} aria-label="menu">
        <MenuIcon />
      </IconButton> */}
      <InputBase
        required={true}
        className={classes.input}
        placeholder="Enter your search as Zip Code Food Name"
        // inputProps={{ 'aria-label': 'search food' }}
        value={srchTxt}
        onChange={changeSrchtext}
        disabled={srchingflg}
        onKeyDown ={onKeyUp}
      />
      {srchingflg && <CircularProgress color="secondary" />}
      {!srchingflg && <IconButton  className={classes.iconButton} aria-label="search" onClick={getSrchResults} >
        <SearchIcon  />
      </IconButton>}
      
      {/* <Divider className={classes.divider} orientation="vertical" />
      <IconButton color="primary" className={classes.iconButton} aria-label="directions">
        <DirectionsIcon />
      </IconButton> */}
    </Paper>
      </div>
    
  );
}
